<div class="container" [ngClass]="{ right: isRight, left: !isRight }">
    <button (click)="togglePanel()" class="panel-toggle" [ngClass]="isRight ? 'right' : 'left'">
        <div class="chevrons">
            <ng-container *ngIf="visible && isRight; then chevronRight"></ng-container>
            <ng-container *ngIf="!visible && isRight; then chevronLeft"></ng-container>
            <ng-container *ngIf="visible && !isRight; then chevronLeft"></ng-container>
            <ng-container *ngIf="!visible && !isRight; then chevronRight"></ng-container>
            <ng-template #chevronRight>
                <img src="assets/icons/chevron-right.svg" alt="chevron right" />
            </ng-template>
            <ng-template #chevronLeft>
                <img src="assets/icons/chevron-left.svg" alt="chevron left" />
            </ng-template>
        </div>
    </button>
    <button *ngIf="isRight" class="panel-toggle tab" (click)="openTabOverlay($event)">
        <div class="chevrons">+</div>
    </button>
    <div class="panel" [ngClass]="{ visible: visible }">
        <div class="content">
            <ng-content></ng-content>
        </div>
    </div>
</div>
<ng-template cdkPortal>
    <ng-container *ngIf="tabOverlayOpen">
        <div class="tab-selection-overlay">
            <div class="tab-entries">
                <ng-container *ngFor="let entry of tabEntries">
                    <button
                        type="button"
                        class="tab-entry-button"
                        (click)="showTabContent(entry.key)"
                        [class.highlight]="entry.value === currentTab"
                    >
                        {{ entry.value }}
                    </button>
                </ng-container>
            </div>
        </div>
    </ng-container>
</ng-template>
